import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/* Admin-editable News / Advisory feed. Firestore doc `news/current` = { items: NewsItem[] }.
   Edited in the admin (AdminNews), read on the client dashboard via useNews(). Ships with
   placeholder content so the section is never empty before an admin curates it. */

export type NewsItem = {
  id: string;
  title: string;
  category: string;
  url: string;       // external article link (Bilal's "link already shared" model)
  image: string;     // cover image URL (optional)
  author: string;
  readTime: string;  // e.g. "5 min read"
  published: boolean;
};

export const DEFAULT_NEWS: NewsItem[] = [
  {
    id: 'placeholder-1',
    title: `New R&D tax incentives every UAE founder should claim in ${new Date().getFullYear()}`,
    category: 'Tax & Compliance',
    url: '',
    image: '',  // was a US IRS tax-forms photo — wrong country for a UAE feed
    author: 'Conncct Advisory',
    readTime: '5 min read',
    published: true,
  },
];

export function useNews(): NewsItem[] {
  const [items, setItems] = useState<NewsItem[]>(DEFAULT_NEWS);
  useEffect(() => {
    const ref = doc(db, 'news', 'current');
    return onSnapshot(ref, snap => {
      const d = snap.data() as { items?: NewsItem[] } | undefined;
      const list = Array.isArray(d?.items) ? d!.items.filter(n => n && n.published) : [];
      setItems(list.length ? list : DEFAULT_NEWS);
    }, () => { /* permission/transient errors: keep placeholder */ });
  }, []);
  return items;
}
